import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-4">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        
        <p className="text-sm">
          &copy; {new Date().getFullYear()} MAC LABS LIMITED. All rights reserved.
        </p>
        
        {/* <p className="mt-2 md:mt-0">
          Designed & Developed by{" "}
          <span className="text-blue-400 hover:text-blue-300">Abhishek Bejawada</span>
        </p> */}
        
        <div className="mt-2 md:mt-0 flex flex-wrap justify-center">
          <Link
            to="/privacy"
            className="text-sm hover:underline mx-2"
            title="Privacy Policy"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            className="text-sm hover:underline mx-2"
            title="Terms & Conditions"
          >
            Terms & Conditions
          </Link>
          <Link
            to="/disclaimer"
            className="text-sm hover:underline mx-2"
            title="Disclaimer"
          >
            Disclaimer
          </Link>
        </div>
      </div>
    </footer>
  );
}
